let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cWX9G")).then(() => parcelRequire('e6bYk'));